import 'sweetalert2/dist/sweetalert2.css';
import 'leaflet/dist/leaflet.css';
import './assets/js/nav-pills.js';
import './assets/scss/argon-dashboard.scss';
import './assets/css/custom.css';

export default {
  install() { },
};
